import { User } from '@/modules/user/types';
import { all_roles } from '@/utils';

const access_roles = {
  [User.Pages.PROFILE]: all_roles,
  [User.Pages.CHANGE_EMAIL]: all_roles,
  [User.Pages.CHANGE_PASSWORD]: all_roles,
};

export default access_roles;
